/********************************************************************************
 * @author       Tech.us
 * @module       AuthModule
 * @name         Login
 * @description  Component for logging in to the application
 * @copyright    Tech.us
 * @Createdon    Apr 2025
 * @since        1.0
 *********************************************************************************/

import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../reduxtoolbox/actions/authSlice.js';
import { useNavigate, Navigate, useLocation } from 'react-router-dom';
import CryptoJS from 'crypto-js'
import Bowser from 'bowser';
import AlertModal from '../../genriccomponents/AlertModal';
import validator from "validator";
import { ForgotPassword, LoginUser,LogOutUser } from '../../services/techus-services.js'
import CONFIG from '../../config/config.js';
import { encryptHandler } from '../../utils/techus-SecureServiceUtils.js';
import { HamrickPrecastLogo } from '../../assets/Images/logos'
import { showToast } from '../../genriccomponents/techus-ToastNotification.js';
import './login.css'
import TinyWhiteLoader from '../../genriccomponents/loaders/TinyWhiteLoader.js';

const Login = () => {
  const [email, setEmail] = useState("");
  const [forgetPasswordEmail, setForgetPasswordEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberme, setRememberme] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [showLogin, setShowLogin] = useState(true);
  const [errMsg, setErrMsg] = useState("");
  const [succMsg, setSuccMsg] = useState("");
  const [passwordEye, setPasswordEye] = useState(false);
  const [passwordType, setPasswordType] = useState('password')
  const passwordTextShow = useRef();
  const refFocus = useRef();
  const [showForgetPassword, setshowForgetPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ title: '', content: '' });
  const errors = {};
  const [platformInfo, setPlatformInfo] = useState({
    osName: '',
    osVersion: '',
    browserName: '',
    browserVersion: '',
  });

  const d = new Date();
  let year = d.getFullYear();
  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // For Restore user purposes
  const [isRestore, setIsRestore] = useState(false);
  const [userId, setUserId] = useState('');
  const [restoreText, setRestoreText] = useState('')
  const search = useLocation().search;
  const user_id = new URLSearchParams(search).get("user_id");
  const restore_user = new URLSearchParams(search).get("restore_user");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_access_token, user } = useSelector((state) => state.auth);


  if (user_access_token) {
    return user?.role === 'admin' ? <Navigate to="/admin" /> : <Navigate to="/profile" />;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      setEmail(value);
    } else if (name === "password") {
      const trimmedValue = value.replace(/\s/g, '');
      setPassword(trimmedValue);
    } else if (name === "remember") {
      setRememberme(e.target.checked);
    } else if (name === "forget_email") {
      setForgetPasswordEmail(value);
    }
  };

  useEffect(() => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const os = browser.getOS();
    const browserInfo = browser.getBrowser();
    setPlatformInfo({
      osName: os.name,
      osVersion: os.versionName || os.version,
      browserName: browserInfo.name,
      browserVersion: browserInfo.version,
    });
  }, []);

  const showForgetPasswordContent = () => {
    setErrMsg('');
    setSuccMsg('');
    setFormErrors({});
    setForgetPasswordEmail(email)
    // form value reset
    if (getCookie('WHPemail') === '' && getCookie('WHPpassword') === '') {
      setEmail('');
      setPassword('');
    }
    setShowLogin(false);
    setshowForgetPassword(true);
  };

  

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    if (getCookie('rememberme')) {
      setEmail(getCookie('WHPemail'));
      var pass = getCookie('WHPpassword');
      var bytes = CryptoJS.AES.decrypt(pass, 'my-secret-key@123');
      var password_data = bytes.toString(CryptoJS.enc.Utf8);
      setPassword(password_data);
      setRememberme(true);
    }
  }, []);

  const showLoginContent = () => {
    setErrMsg('');
    setSuccMsg('');
    setPasswordType('password')
    setshowForgetPassword(false);
    setShowLogin(true);
  };

  // password eye icon code
  const passwordView = (text) => {
    if (text !== '') {
      setPasswordEye(true);
    } else {
      setPasswordEye(false);
    }
  }
  const showPassword = (e) => {
    e.preventDefault()
    if (passwordTextShow.current.type === 'password') {
      passwordTextShow.current.setAttribute('type', 'text')
      setPasswordType('text')
    } else {
      passwordTextShow.current.setAttribute('type', 'password')
      setPasswordType('password')
    }

  }
  useEffect(() => {
    passwordView(password);
  }, [password])


  const runValidations = () => {
    // Password Validations
    if (password?.trim() == '' || password == undefined || password == null) { errors['password'] = 'Password is required' }
    // Email validations
    if (email.trim().length === 0) {
      errors.email = "Email Address is required";
    } else if (!validator.isEmail(email.trim())) {
      errors.email = "Invalid Email Address ";
    }
    // setTimeout(() => {
    // 	setFormErrors({})
    // }, CONFIG.setTimeout);
  };

  const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let browserInfo = {};
  
    // Detect browser name and version
    if (/Firefox[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Firefox';
      browserInfo.version = RegExp.$1;
    } else if (/Chrome[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Chrome';
      browserInfo.version = RegExp.$1;
    } else if (/Edge[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Edge';
      browserInfo.version = RegExp.$1;
    } else if (/Safari[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Safari';
      browserInfo.version = RegExp.$1;
    } else {
      browserInfo.name = 'Unknown';
      browserInfo.version = 'Unknown';
    }
  
    return browserInfo;
  };
  const getOsInfo = () => {
    const userAgent = navigator.userAgent;
    let osInfo = {};
  
    // Detect OS name and version
    if (/(Windows NT ([\d\.]+))/.test(userAgent)) {
      osInfo.name = 'Windows';
      const fullVersion = RegExp.$1;
      const versionParts = fullVersion.split(' ').pop().split('.'); // Split by spaces and dots
      osInfo.version = versionParts[0]; // Get major version (e.g., 10)
    } else if (/(Mac OS X [\d_]+)/.test(userAgent)) {
      osInfo.name = 'Mac OS X';
      osInfo.version = RegExp.$1.replace(/_/g, '.');
    } else if (/(Linux [a-z0-9_\.\/-]+)/i.test(userAgent)) {
      osInfo.name = 'Linux';
      osInfo.version = 'Unknown'; // Not easy to determine specific Linux version from userAgent
    } else {
      osInfo.name = 'Unknown';
      osInfo.version = 'Unknown';
    }
  
    return osInfo;
  };

  
  
  // Usage example to get OS and browser info
  const osInfo = getOsInfo();
  const browserInfo = getBrowserInfo();
  
  // Example of how to use these values in an API request header
  const headers = {
    osName: osInfo.name,
    osVersion: osInfo.version,
    browserName: browserInfo.name,
    browserVersion: browserInfo.version,
  };


  const params = new URLSearchParams(headers);

  const authLogOut = async()=>{
    const response = await LogOutUser(params)
    if(response.valid){
      localStorage.removeItem("user_access_token");
      localStorage.clear();
      setLoader(false)
      navigate("/login");
    }else{
      setLoader(false)
      return false
    } 
  }

  // validations and error pops and timeout code
  useEffect(() => {
    setFormErrors({})
  }, [password, email]);

  const handleSubmit = async (e) => {
    const token_data = localStorage.getItem('user_access_token')
    var device_info = {
      ...platformInfo
    }

    e.preventDefault();
    runValidations();
    // if(token_data){
    //   const response = await LogOutUser(params)
    //   if(response.valid){
    //     localStorage.removeItem("user_access_token");
    //     localStorage.clear();
       
    //   }
    // }
    if (Object.keys(errors).length === 0) {
      setFormErrors({});
      setIsLoading(true)
      const formData = {
        email_id: email.trim(),
        password: password,
        rememberme,
        device_info
      };

      const response = await LoginUser(formData);
      if (!response) { showToast('error', 'Login failed: no response from server'); setIsLoading(false); return; }
      if (response.valid == true) {
        if(token_data){
        const res = await LogOutUser(params)
        }
        const user = { username: response?.user_data, role: 'username' === 'admin' ? 'admin' : 'user' };
        const token = response.token;
        localStorage.setItem("user_access_token", response.token);
        localStorage.setItem("isAuthenticated", true);
        localStorage.setItem("uuid", response.user_data?.id);

        const d = new Date();
        d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        var ciphertext = CryptoJS.AES.encrypt(
          formData.password,
          "my-secret-key@123"
        ).toString();
        if (formData.rememberme === true) {
          document.cookie = "rememberme=true;" + expires + ";";
          document.cookie = "WHPpassword=" + ciphertext + ";" + expires + ";";
          document.cookie = "WHPemail=" + formData.email_id + ";" + expires + ";";
        } else {
          document.cookie = "rememberme=;" + expires + ";";
          document.cookie = "WHPassword=;" + expires + ";";
          document.cookie = "WHPemail=;" + expires + ";";
        }
        dispatch(login({ user, token }));

        if (user.role === 'admin') {
          navigate('/admin');
        } else {
          navigate('/projects');
        }
        setIsLoading(false)
      } else {
        showToast('error', response.message)
        setIsLoading(false)
      }
    } else {
      setIsLoading(false);
      // console.log("login form errors", errors);
      setFormErrors(errors);
    }
  };


  const forgetPasswordValidations = () => {
    if (forgetPasswordEmail.trim().length === 0) {
      errors.forgetPasswordEmail = "Email Address is required";
    } else if (!validator.isEmail(forgetPasswordEmail.trim())) {
      errors.forgetPasswordEmail = "Invalid email Address";
    }
    setTimeout(() => {
      setFormErrors({})
    }, 8000);
  };


  const handleForgetPasswordSubmit = async (e) => {
    setLoader(true)
    e.preventDefault();
    forgetPasswordValidations();

    if (Object.keys(errors).length === 0) {
      setIsLoading(true)
      setFormErrors({});
      const formData = {
        email_id: forgetPasswordEmail.trim()
      };

      const response = await ForgotPassword(formData);
      if (response.valid == true) {
        showToast('success', response.message)
        setForgetPasswordEmail('');
        setIsLoading(false)
      }else if(!response?.valid && response.message=='already_login'){
        setIsLoading(false)
        const data_3 = { head: "You're Already Logged In", text: "You're already logged in. Please go to the main page to continue." };
        setModalData({ title: data_3.head, content: data_3.text });
        setShowModal(true);
     }
       else {
        showToast('error', response.message)
        setIsLoading(false)
      }
    } else {
      setIsLoading(false)
      setFormErrors(errors)
    
  }
  }
  
  const handleLogoutOkay =()=>{
    window.location.reload()
  }

  return (
    <>
      {showModal && (
        <AlertModal
          button="Okay"
          title={modalData.title}
          content={modalData.content}
          handleOkay={handleLogoutOkay}
        />
      )}
      {/* Login module */}
      <div className='row login-wrapper'>
        <div className='col-lg-6 col-sm-12 login-letf'>
          <div className='left-bottom-box'>
            <p className='left-header-text animate__animated animate__bounceInLeft '>
              WHP AI  <br />
              Quoting Tool
            </p>
            <p className='text-white text-25 animate__animated animate__zoomIn animate__delay-1s '>An AI powered tool that converts your <br /> plans to submittals.</p>

          </div>
        </div>

        <div className='col-lg-6 position-relative  col-sm-12 d-dlex justify-content-center align-item-center  '>
          <div className='d-flex align-item-center justify-content-center '>
            <img className='login-right-logo animate__animated animate__slideInRight' src={HamrickPrecastLogo} alt="Hamrick Precast" />

          </div>
          {!showForgetPassword &&
            <div className='animate__animated animate__slideInRight mb-5' >
              <div className='text-center margin-top-30 '>
                <p className='text-30 text-bold-800'>Log In</p>
                <p className='text-16 color-light-grey'>Please Log in to access your account.</p>
              </div>
              <div className='d-flex justify-content-center margin-top-35'>
                <div>
                  <form onSubmit={handleSubmit} autoComplete="off" noValidate className="form-group">

                    <div className=''>
                      <span className='text-14 text-bold-700'>Email Address <span className='red-color'>*</span></span>
                      <label className="label">

                        <input ref={refFocus}
                         tabIndex='1'
                          type="text"
                          className="input"
                          id="emailw"
                          onBlur={runValidations}
                          value={email}
                          onChange={handleChange}
                          name="email"
                          placeholder="Enter your email address"
                          autoComplete="new-passwords"
                        />
                        <i className="people-login-icon icon icon-people">
                        </i>
                        <span className="input-border"></span>
                      </label>
                      {formErrors.email && (
                        <span className="login-error"> {formErrors.email} </span>
                      )}
                      <div className='pass-box'>
                        <span className='text-14 text-bold-700 '>Password <span className='red-color'>*</span></span>
                        <label className="label">

                          <input
                          
                            ref={passwordTextShow} tabIndex='2' className="input" type="password" id="password"
                            value={password}
                            onBlur={runValidations}
                            placeholder="Enter your password"
                            onChange={handleChange} required
                            autoComplete="passwords" name="password"
                          />
                          <i onClick={showPassword} className={passwordType !== "password" ? "icon-view people-login-icon cursor-pointer" : "cursor-pointer icon-hide people-login-icon"}></i>
                          <span className="input-border"></span>
                        </label>
                        {formErrors.password && (
                          <span className="login-error"> {formErrors.password} </span>
                        )}
                        <div className="mb-3  remember-box">
                          <div className=" d-flex justify-content-between align-items-center">
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="checkbox-wrapper-46">
                                <input type="checkbox" checked={rememberme} name="remember" onChange={handleChange} id="cbx-46" className="inp-cbx" />
                                <label htmlFor="cbx-46" className="cbx"
                                ><span>
                                    <svg viewBox="0 0 12 10" height="10px" width="12px">
                                      <polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg></span
                                  ><span></span>
                                </label>
                              </div>
                              <label className="color-light-grey remember-me" htmlFor="remember">Remember me</label>
                            </div>
                            <div>
                              <p type="button" tabIndex='4' className="recovery btn-reset table-link-active margin-top-13" onClick={showForgetPasswordContent}>Forgot Password?</p>
                            </div>
                          </div>
                        </div>
                        <div className="submit">
                          {isLoading ?
                            <button className={' button2'} disabled={isLoading}>{<TinyWhiteLoader />} </button>
                            :
                            <button className={' button2'} disabled={isLoading}><span className='my-1'>Log In</span>  </button>
                          }
                        </div>
                        <p className='text-13 text-center color-light-grey margin-top-13 mt-3'>By Clicking “Log In” you agree to our <span className='color-light-blue'>Terms of Use</span> and <span className='color-light-blue'>Privacy Policy</span>.</p>
                      </div>
                    </div>
                  </form>

                </div>
              </div>
            </div>}
          {showForgetPassword &&
          <div className='animate__animated animate__slideInRight mb-5'>
              <div className='text-center margin-top-84 '>
                <p className='text-30 text-bold-800'>Forgot Password</p>
                <p className='text-16 color-light-grey'>
Please provide the verified email address associated with your account,<br/> and we will send you a link to reset your password.
 </p>
              </div>
              <div className='d-flex justify-content-center margin-top-50'>
                <div>
                  <form onSubmit={handleForgetPasswordSubmit} autoComplete="login" noValidate className="fp-form">

                    <div className='login-input-container'>
                      <span className='text-14 text-bold-700'>Email Address <span className='red-color'>*</span></span>
                      <label className="label">
                        <input
                          type="text"
                          className="input"
                          tabIndex='1'
                          onBlur={runValidations}
                          onChange={handleChange}
                          name="forget_email" value={forgetPasswordEmail}
                          placeholder="Enter your email address"
                         autoComplete="new-password"
                        />
                        <i className="people-login-icon icon icon-people">
                        </i>
                        <span className="input-border"></span>

                      </label>
                      {formErrors.forgetPasswordEmail && (
                        <span className="login-error"> {formErrors.forgetPasswordEmail} </span>
                      )}
                      <div className='pass-box'>
                        <div className="submit">
                          <button className={isLoading ? 'loading-button2 button2' : 'button2'} disabled={isLoading}>{isLoading ? <TinyWhiteLoader /> : 'Submit'} </button>
                        </div>
                        <div tabIndex='0' className="fp-signup text-center">
                          <span tabIndex='3' className="color-light-blue text-14 mt-5  btn-reset table-link-active" href={() => false} onClick={showLoginContent}>
                            <i className="icon-back fp-icon-back me-2"></i>
                            Back to Login
                          </span>
                        </div></div>
                    </div>
                  </form>
                </div>
              </div>
            </div>}
          <div className='fixed-bottom text-center position-absolute'><p className='text-13 color-dark-grey'>All rights reserved © {new Date().getFullYear()} Wellington Hamrick Precast</p></div>
        </div>
      </div>
    </>

  );
};

export default Login;
